import apiService from "../../api/api.service";
import { MenusResponse } from "./menus.types";

export const fetchMenus = async (): Promise<MenusResponse> => {
  return apiService.get<MenusResponse>("/menus");
};